
const Pristanak = function(DS) {
    return DS.defineResource({
        name: 'Pristanak',
        endpoint: '/pristanci'
    });
};

Pristanak.$inject = ['DS'];


export {Pristanak};



// WEBPACK FOOTER //
// ./app/models/pristanak.js